export const GET_MANAGEMENT_LIST_REQUEST = 'GET_MANAGEMENT_LIST_REQUEST';
export const GET_MANAGEMENT_LIST_SUCCESS = 'GET_MANAGEMENT_LIST_SUCCESS';
export const GET_MANAGEMENT_LIST_FAILURE = 'GET_MANAGEMENT_LIST_FAILURE';